import {ApiException, ValidationError} from '@dms/api/shared';

export type WithValidationErrors<T> = T | ValidationError[];

export function isApiException(x: any): x is ApiException {
  return x.validationErrors !== undefined;
}

export type {ApiException};
